import { DesignAutomationsPage } from "@/features/design/report-automations/ReportAutomationsDemo";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/features/worklist/automations")({
    component: DesignAutomationsRoute,
});

function DesignAutomationsRoute() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Worklist", route: { to: "/design/features/worklist" } },
        { label: "Automations", route: { to: "/design/features/worklist/automations" } },
    ]);

    return <DesignAutomationsPage />;
}
